import { GEAR_SLOTS, type GearSlot } from '../model/types';

const KEY = 'threadbound.bag.view.v1';

export type BagFilter = 'all' | GearSlot;
export type BagSort = 'high' | 'low';

export interface BagView {
  filter: BagFilter;
  sort: BagSort;
}

export function readBagView(): BagView {
  const fallback: BagView = { filter: 'all', sort: 'high' };
  if (typeof localStorage === 'undefined') return fallback;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as Partial<BagView>;
    const filter = parsed.filter === 'all' || (typeof parsed.filter === 'string' && GEAR_SLOTS.includes(parsed.filter as GearSlot))
      ? parsed.filter
      : 'all';
    const sort = parsed.sort === 'low' ? 'low' : 'high';
    return { filter, sort };
  } catch {
    return fallback;
  }
}

export function writeBagView(view: BagView): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(KEY, JSON.stringify(view));
}
